import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import Footer from './Footer';

function PrivacyPolicy() {
  return (
    <div className="App" style={{ paddingBottom: 'calc(120px + var(--spacing-lg))' }}>
      <header className="App-header" style={{ paddingBottom: '2em' }}>
        <h1 style={{ color: 'var(--color-green-primary)' }}>Privacy Policy</h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: '1.5em' }}>
          <em>Last updated: June 2026</em>
        </p>

        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'left', lineHeight: '1.8' }}>
          <h2>1. Introduction</h2>
          <p>
            Canopy Biosystems Inc ("Company", "we", "our", or "us") provides dendrometer sensor hardware, embedded firmware, mobile and web software, and the Canopy Sensor Data Dashboard (collectively, the "Products and Services"). This page informs you of our policies regarding the collection, use, and disclosure of data when you purchase, activate, install, or use our Products and Services, and the choices you have associated with that data.
          </p>
          <p>
            By using our Products and Services, you consent to the collection and use of data as described in this policy. This consent is a condition of using the Products and Services, as the data collected is necessary to provide, operate, and improve them.
          </p>

          <h2>2. Data We Collect</h2>
          <p>
            We collect the following categories of data in order to provide and improve the Products and Services:
          </p>
          <ul>
            <li><strong>Account Information:</strong> When you create an account, we collect your email address and any profile details you provide.</li>
            <li><strong>General Location Data:</strong> Approximate location (e.g., zip code or region) associated with your devices. This is used to contextualize sensor data with local climate and environmental conditions and is not used to precisely identify your address.</li>
            <li><strong>Sensor Data:</strong> Time-series measurements transmitted by your connected devices, including plant stem diameter readings, temperature, moisture, and related environmental data. This data is the core output of the Products and Services and is required to deliver them.</li>
            <li><strong>Device Identifiers:</strong> Serial numbers and hardware identifiers associated with your sensors, used to link devices to your account and deliver data correctly.</li>
            <li><strong>Firmware and Device Diagnostics:</strong> Firmware version, device health metrics, connectivity status, and error logs transmitted by your hardware. This data is used to support OTA updates, troubleshoot issues, and maintain device performance.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with the Dashboard and software, including IP address, browser type, pages visited, time and duration of visits, and other diagnostic data.</li>
            <li><strong>Cookies and Tracking:</strong> We use cookies and similar technologies to maintain sessions, remember preferences, and analyze Dashboard usage.</li>
          </ul>

          <h2>3. How We Use Your Data</h2>
          <p>
            Canopy Biosystems Inc uses the collected data for the following purposes:
          </p>
          <ul>
            <li>To operate, provide, and maintain the Products and Services</li>
            <li>To deliver sensor readings and analytics to your Dashboard</li>
            <li>To issue and manage firmware updates to your devices</li>
            <li>To provide customer support and respond to inquiries</li>
            <li>To notify you about changes to the Products and Services</li>
            <li>To analyze usage patterns and improve the Products and Services</li>
            <li>To detect, prevent, and address technical issues or security incidents</li>
            <li>To develop new features and products</li>
          </ul>
          <p>
            We do not sell your personal data to third parties.
          </p>

          <h2>4. Data Retention</h2>
          <p>
            We retain your data for as long as your account is active or as needed to provide the Products and Services. Sensor and device data may be retained beyond account closure in anonymized or aggregated form for research and product improvement purposes.
          </p>

          <h2>5. Security of Data</h2>
          <p>
            The security of your data is important to us. We use commercially reasonable technical and organizational measures to protect your data. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2>6. Your Rights</h2>
          <p>
            You may request access to, correction of, or deletion of your personal data at any time by contacting us. Note that deletion of account data may limit our ability to provide the Products and Services.
          </p>

          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of significant changes by updating the date at the top of this page. Continued use of the Products and Services after changes are posted constitutes acceptance of the updated policy.
          </p>

          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul>
            <li>By visiting this page on our website: <Link to="/contact-us" style={{ color: 'var(--color-green-primary)' }}>Contact Us</Link></li>
          </ul>
        </div>
      </header>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
